<script lang="ts">
    import { sineIn } from "svelte/easing";

    type Size = "small" | "medium";

    //Props
    export let progress: number;

    //Optional props
    export let size: Size = "small";

    const parseProgress = (progress: number): number => {
        if (progress < 0) return 0;

        if (progress > 100) return 100;

        return progress;
    };

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const widthTransition = (node: HTMLElement) => ({
        delay: 0,
        duration: 300,
        easing: sineIn,
        css: (t: number) => `width: ${t};`,
    });

    $: parsedProgress = parseProgress(progress);
</script>

<div class="gw-progress-bar">
    <div
        class="gw-progress-bar__inner"
        class:gw-progress-bar__inner--small={size === "small"}
        class:gw-progress-bar__inner--medium={size === "medium"}
    >
        {#if parsedProgress}
            <div
                class="gw-progress-bar__fill"
                style="--gw-progress-bar-width: {parsedProgress}%"
                in:widthTransition
            />
            <progress
                class="gw-progress-bar__progress"
                value={parsedProgress}
                max="100"
                aria-valuemin="0"
                aria-valuenow={parsedProgress}
                aria-valuemax="100"
            />
        {/if}
    </div>
    <slot />
</div>

<style lang="postcss">
    .gw-progress-bar {
        position: relative;
        width: 100%;

        &__inner {
            position: relative;
            width: 100%;
            overflow: hidden;
            background-color: var(--gw-empty-progress-bar-bg-color);
            border-radius: var(--gw-border-radius-md);

            &--small {
                height: 8px;
            }

            &--medium {
                height: 16px;
            }
        }

        &__fill {
            width: var(--gw-progress-bar-width);
            height: 100%;
            background-color: var(--gw-filled-progress-bar-bg-color);
        }

        &__progress {
            position: absolute;
            top: 0;
            width: 1px;
            height: 1px;
            margin: 0;
            padding: 0;
            overflow: hidden;
            border: 0;
            white-space: nowrap;
        }
    }
</style>
